<h1 class="mine-title-l maintenance__title">{{ 'maintenance.header' | content }}</h1>

<p class="maintenance__text">{{ 'maintenance.text' | content }}</p>

<img ngSrc="{{assetsUrl}}/Portal/sima-in-a-rocket.png" width="380" height="285" class="maintenance__img">